import { ApproveOrRejectDialog } from "@common/components/ApproveOrRejectDialog";
import { ExpenseReportStatus } from "@common/utils/graphql";

interface Props {
  onConfirm: (action: ExpenseReportStatus, notes?: string) => void;
  isLoading: boolean;
  isApprovingAll: boolean;
  isRejectingAll: boolean;
  employeeName: string;
  renderTrigger: () => JSX.Element;
}

export const ApproveOrRejectReportDialog = ({
  onConfirm,
  isLoading,
  isApprovingAll,
  isRejectingAll,
  employeeName,
  renderTrigger,
}: Props) => {
  const description = isApprovingAll
    ? `Optionally add a note to let ${employeeName} know why their reimbursement is being approved.`
    : isRejectingAll
      ? `Let ${employeeName} know why their report is being rejected.`
      : `Let ${employeeName} know why some of their expenses are being rejected.`;

  const title = isApprovingAll
    ? "Approve Report"
    : isRejectingAll
      ? "Reject Report"
      : "Partially Approve Report";

  const textareaPlaceholder = isRejectingAll
    ? "This report is out of policy because..."
    : "Add a note...";

  const handleConfirm = (notes?: string) => {
    const action = isApprovingAll
      ? ExpenseReportStatus.Approved
      : isRejectingAll
        ? ExpenseReportStatus.Rejected
        : ExpenseReportStatus.PartiallyApproved;

    onConfirm(action, notes);
  };

  return (
    <ApproveOrRejectDialog
      onConfirm={handleConfirm}
      isLoading={isLoading}
      isRequired={!isApprovingAll}
      textareaPlaceholder={textareaPlaceholder}
      title={title}
      description={description}
      renderTrigger={renderTrigger}
    />
  );
};
